module.exports = __webpack_public_path__ + "static/oralignLogo-fc03bd8cd4169412922e32672b66ae01.svg";